<template>
  <div class="container mt20" v-loading="isLoading">
    <div class="relative">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="containers mb10">
        <el-breadcrumb-item :to="{ path: '/teacher' }">师资专家</el-breadcrumb-item>
        <el-breadcrumb-item><span class="hover">师资详情</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if="detail">
      <div class="flex between start nowrap containers mt20 mb80">
        <div class="mr20" style="flex: 1">
          <div class="BGwhite pad24 radius8 gray1 flex nowrap initial relative">
            <img :src="detail.Avatar" class="ImgPath" @error="imgError" alt="" />
            <div class="ml30 flex1 right-box">
              <p class="ellipsis2 b500 size30 mt10 ohide">
                {{ detail.TeacherName }}
              </p>
              <div class="Props">
                <template v-for="(item, index) in detail.Props">
                  <div v-if="item.PropValue" class="Props-item" :key="index">
                    <!-- <img src="@/assets/img/home/4.png" alt="" class="mr5" /> -->
                    <span class="PropName">{{ item.PropName }}：</span><span class="PropValue">{{ item.PropValue
                    }}</span>
                  </div>
                </template>
              </div>
              <div class="flex Price">
                <div class="nowrap">
                  <el-button class="sub-btn" @click="booking">讲师预约</el-button>
                </div>
              </div>
            </div>
          </div>
          <ul class="flex C666 b500 part04 size16 BGwhite radius8 gray1 mt10">
            <template>
              <li :class="{ Con: tab == 1 }" @click="tab = 1">介绍</li>
              <li :class="{ Con: tab == 2 }" @click="tab = 2">课程</li>
              <li :class="{ Con: tab == 3 }" @click="tab = 3">资料</li>
              <li :class="{ Con: tab == 4 }" @click="tab = 4">活动</li>
            </template>
          </ul>
          <div class="pad25 radius8 ohide BGwhite radius8 gray1 mt1 detail-tab-box" v-if="detail">
            <div v-show="tab == 1" class="jieshao">
              <p v-if="detail.Labels.length > 0" class="my-b-tit mt20">
                讲师标签
              </p>
              <div class="keywords mt10">
                <span v-for="(tag, k) in detail.Labels" :key="tag + k">
                  #{{ tag.LabelName }}
                </span>
              </div>
              <div v-for="(it, k) in detail.Descs" :key="k">
                <div v-if="detail.Descs.length > 0" class="my-b-tit mt30">
                  {{ it.Title }}
                </div>
                <div class="keywords mt10">
                  <span v-html="it.Body"> </span>
                </div>
              </div>
            </div>
            <course v-show="tab == 2" :id="detail.TeacherID"></course>
            <fileList v-show="tab == 3" :id="detail.TeacherID"></fileList>
            <activity v-show="tab == 4" :id="detail.TeacherID"> </activity>
          </div>
        </div>
        <rightSide class="width290px" v-if="!isLoading" />
      </div>
    </div>
    <el-dialog title="预约讲师" :visible.sync="dialogShow" class="width510" @close="close" :append-to-body="true">
      <div class="my-form">
        <div class="flexs">
          <div class="mt-form-item">
            <div class="label">
              联系人姓名
              <span class="must">(必填)</span>：
            </div>
            <el-input v-model="model.RealName" placeholder="请填写联系人姓名"></el-input>
          </div>
          <div class="mt-form-item">
            <div class="label">
              联系人电话
              <span class="must">(必填)</span>：
            </div>
            <el-input v-model="model.Phone" placeholder="请填写联系人电话"></el-input>
          </div>
        </div>
        <div class="mt-form-item">
          <div class="label">
            课程需要
            <span class="must">(非必填)</span>：
          </div>
          <el-input v-model="model.Body" placeholder="请填写您的课程需求" type="textarea" :rows="8"></el-input>
        </div>
        <div class="mt-form-item valiCode">
          <el-input placeholder="验证码" v-model="model.valiCode"> </el-input>
          <identify ref="identify" :height="46" :width="150" class="identify" />
        </div>
      </div>
      <div slot="footer">
        <el-button class="submit-btn" @click="submit()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Teacher_GetDetail, Teacher_Prebook } from "@/api/teacher";
import activity from "./child/activity.vue";
import rightSide from "./child/rightSide.vue";
import course from "./child/course.vue";
import fileList from "./child/fileList.vue";
import identify from "@/components/identify.vue";
export default {
  name: "teacherDetail",
  components: {
    activity,
    fileList,
    course,
    rightSide,
    identify,
  },
  data() {
    return {
      tab: 1,
      dialogShow: false,
      model: {
        RealName: "",
        Phone: "",
        Body: "",
        valiCode: "",
      },
      isLoading: false,
      detail: null,
      keywords: [],
    };
  },
  watch: {
    "$route.query.tab"(newValue) {
      if (newValue === undefined) {
        this.$router.go(0);
      }
    },
    "$route.query.TeacherID"(newValue) {
      if (newValue) {
        this.getDetail();
      }
    },
    tab(v) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: v,
        },
      });
    },
  },
  created() {
    const { tab } = this.$route.query;
    if (tab) {
      this.tab = Number(tab);
    }

    this.getDetail();
  },
  methods: {
    submit() {
      if (this.model.RealName.trim().length === 0) {
        this.$message.error("联系人姓名不能为空");
        return false;
      }
      if (this.model.Phone.trim().length === 0) {
        this.$message.error("联系人电话不能为空");
        return false;
      }
      if (this.model.valiCode.trim().length === 0) {
        this.$message.error("图片验证码不能为空");
        return false;
      } else if (this.model.valiCode !== this.$refs.identify.identifyCode) {
        this.$message.error("图片验证码不正确");
        return false;
      }
      Teacher_Prebook({
        ...this.model,
        TeacherID: this.$route.query.TeacherID,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("预约成功");
          this.dialogShow = false;
        } else {
          this.$refs.identify.drawPic();
        }
      });
    },
    booking() {
      this.dialogShow = true;
    },
    close() {
      this.dialogShow = false;
      this.model = {
        RealName: "",
        Phone: "",
        Body: "",
        valiCode: "",
      };
      this.$refs.identify.drawPic();
    },
    getDetail(reload = false) {
      this.detail = null;
      if (!reload) {
        this.isLoading = true;
      }
      Teacher_GetDetail({
        TeacherID: this.$route.query.TeacherID,
      })
        .then((res) => {
          this.isLoading = false;
          this.detail = res.data;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  padding-top: 40px;
}

.detail-tab-box {
  min-height: 900px;
}

.ImgPath {
  width: 256px;
  height: 315px;
  border-radius: 6px;
}

.Props {
  margin-top: 10px;
  margin-bottom: 60px;

  .Props-item {
    height: 36px;

    .PropName {
      font-weight: 400;
      font-size: 18px;
      color: #666666;
    }

    .PropValue {
      font-weight: 400;
      font-size: 18px;
      color: #333333;

    }
  }
}

.sub-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
  position: absolute;
  bottom: 20px;
}

.right-box {
  margin-top: 5px;

  // height: 230px;
  .ClassifyName {
    background: #e5f0ff;
    border-radius: 6px;
    font-size: 16px;
    color: #1d79ff;
    padding: 5px 10px;
  }

  .Body {
    margin-top: 10px;
    font-size: 30px;
    color: #333333;
    font-weight: bold;
  }

  .my-star {
    font-size: 20px;
    display: flex;
    align-items: center;

    .Corange {
      color: #666666;
      font-size: 18px;
      font-weight: 400;
    }

    .user {
      width: 12px;
      height: 17px;
    }

    .time {
      width: 17px;
      height: 17px;
    }
  }
}

.red {
  color: #e12a14;
  font-weight: bold;
}

.jieshao {
  padding-left: 40px;
  font-weight: 400;
  font-size: 18px;
  color: #666666;



  .keywords {
    span {
      margin-right: 20px;
    }
  }
}

.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}

.my-form {
  .mt-form-item {
    margin-bottom: 20px;

    .label {
      font-size: 16px;
      color: #333333;
      margin-bottom: 10px;
    }

    .must {
      color: #ef3d3d;
    }
  }

  ::v-deep .el-input__inner {
    width: 470px;
    height: 46px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }

  .flexs {
    display: flex;
    gap: 10px;

    ::v-deep .el-input__inner {
      width: 228px;
      height: 46px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #e6e6e6;
    }
  }

  .valiCode {
    display: flex;

    ::v-deep .el-input__inner {
      width: 340px;
      height: 46px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #e6e6e6;
    }
  }
}

.identify {
  width: 150px;
  height: 46px;
  overflow: hidden;
  border-radius: 4px;
}

.submit-btn {
  width: 144px;
  height: 46px;
  font-size: 16px;
  color: #ffffff;
  background: #1d79ff;
  border-radius: 6px;
}
</style>
